import styled from 'styled-components';

export const Box = styled.div`
  padding: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 1.5rem 0;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  .hefesto-input-wrapper__label-wrapper__label {
    padding: 0 1rem;
  }

  .hefesto-step-by-step {
    width: 100%;
    margin-top: 2rem;
    margin-right: 0;
  }

  & > div:not(.ContainerStepByStep) {
    @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
      width: 32%;
      margin-right: 1.44rem;
    }

    &.customer-order {
      width: 100%;
      margin-bottom: 0.5rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
        width: 25%;
        margin-bottom: unset;
      }

      & > h4 {
        font-weight: bold;
        font-size: 0.875rem;
      }
    }
  }

  .hefesto-modal__overlay {
    width: 100% !important;
  }
`;

export const EmitterSelectContainer = styled.div`
  width: 368px !important;
`;

export const HeaderErrorContainer = styled.div`
  display: inline-block;
  border: 2px solid #c74a34;
  border-radius: 4px;
  margin-top: 16px;
  background-color: rgba(199, 74, 52, 0.2);
`;

export const HeaderErrorText = styled.span`
  color: #c74a34;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;

  .hefesto-icon svg {
    color: #c74a34;
  }
`;
